export default "__VITE_PUBLIC_ASSET__735e8021__"